var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConnectImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 325,
    height: 200,
    viewBox: "0 0 325 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59",
    transform: "translate(0 -35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1101",
    "data-name": "Path 1101",
    d: "M473.436,256.311H263.261a5.464,5.464,0,0,1-5.411-5.5V119a4,4,0,0,1,3.965-4.032h213a4.073,4.073,0,0,1,4.033,4.1v131.74A5.465,5.465,0,0,1,473.436,256.311Z",
    transform: "translate(-206.9 -75.36)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1102",
    "data-name": "Path 1102",
    d: "M479.774,268.76H283.9a5.094,5.094,0,0,1-5.207-4.96V149.019a3.776,3.776,0,0,1,3.859-3.678h198.51a3.839,3.839,0,0,1,3.923,3.739V263.8A5.094,5.094,0,0,1,479.774,268.76Z",
    transform: "translate(-220.905 -95.604)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1103",
    "data-name": "Path 1103",
    d: "M478.616,109.482h-221v-2.8a5.483,5.483,0,0,1,5.431-5.52H473.185a5.483,5.483,0,0,1,5.431,5.52Z",
    transform: "translate(-206.744 -66.16)",
    fill: "#3c71b6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_32",
    "data-name": "Ellipse 32",
    cx: 1.405,
    cy: 1.522,
    rx: 1.405,
    ry: 1.522,
    transform: "translate(59.339 37.647)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_33",
    "data-name": "Ellipse 33",
    cx: 1.405,
    cy: 1.522,
    rx: 1.405,
    ry: 1.522,
    transform: "translate(64.672 37.647)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_34",
    "data-name": "Ellipse 34",
    cx: 1.405,
    cy: 1.522,
    rx: 1.405,
    ry: 1.522,
    transform: "translate(70.004 37.647)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1104",
    "data-name": "Path 1104",
    d: "M503.27,288.526h-151.8a5.8,5.8,0,0,1-5.739-5.837V208.252a4.334,4.334,0,0,1,4.292-4.366H504.648a4.4,4.4,0,0,1,4.361,4.436v74.367A5.8,5.8,0,0,1,503.27,288.526ZM350.026,204.554a3.672,3.672,0,0,0-3.636,3.7v74.437a5.133,5.133,0,0,0,5.083,5.17h151.8a5.133,5.133,0,0,0,5.084-5.17V208.322a3.741,3.741,0,0,0-3.7-3.768Z",
    transform: "translate(-265.961 -134.621)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1105",
    "data-name": "Path 1105",
    d: "M368.482,294.481h141.3a5.293,5.293,0,0,0,5.247-5.337V226.918a5.293,5.293,0,0,0-5.247-5.337h-141.3a5.293,5.293,0,0,0-5.248,5.337v62.226A5.293,5.293,0,0,0,368.482,294.481Z",
    transform: "translate(-277.722 -146.413)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_35",
    "data-name": "Ellipse 35",
    cx: 2.952,
    cy: 3.002,
    rx: 2.952,
    ry: 3.002,
    transform: "translate(103.852 87.268)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_36",
    "data-name": "Ellipse 36",
    cx: 2.952,
    cy: 3.002,
    rx: 2.952,
    ry: 3.002,
    transform: "translate(103.852 98.609)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_37",
    "data-name": "Ellipse 37",
    cx: 2.952,
    cy: 3.002,
    rx: 2.952,
    ry: 3.002,
    transform: "translate(103.852 109.95)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_38",
    "data-name": "Ellipse 38",
    cx: 2.952,
    cy: 3.002,
    rx: 2.952,
    ry: 3.002,
    transform: "translate(103.852 121.291)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1106",
    "data-name": "Path 1106",
    d: "M569.561,266.522H472.482a.334.334,0,0,1,0-.667h97.079a.334.334,0,0,1,0,.667Z",
    transform: "translate(-350.92 -175.919)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1107",
    "data-name": "Path 1107",
    d: "M569.561,300.522H472.482a.334.334,0,0,1,0-.667h97.079a.334.334,0,0,1,0,.667Z",
    transform: "translate(-350.92 -198.577)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1108",
    "data-name": "Path 1108",
    d: "M569.561,334.522H472.482a.334.334,0,0,1,0-.667h97.079a.334.334,0,0,1,0,.667Z",
    transform: "translate(-350.92 -221.236)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1109",
    "data-name": "Path 1109",
    d: "M569.561,368.522H472.482a.334.334,0,0,1,0-.667h97.079a.334.334,0,0,1,0,.667Z",
    transform: "translate(-350.92 -243.895)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1110",
    "data-name": "Path 1110",
    d: "M506.3,379.2h-9.511a1.656,1.656,0,0,1-1.64-1.668v-9.006a1.656,1.656,0,0,1,1.64-1.668H506.3a1.656,1.656,0,0,1,1.64,1.668v9.006a1.656,1.656,0,0,1-1.64,1.668Z",
    transform: "translate(-366.376 -243.228)",
    fill: "#3c71b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1111",
    "data-name": "Path 1111",
    d: "M571.3,356.538h-9.511a1.656,1.656,0,0,1-1.64-1.668V334.523a1.656,1.656,0,0,1,1.64-1.668H571.3a1.656,1.656,0,0,1,1.64,1.668V354.87A1.656,1.656,0,0,1,571.3,356.538Z",
    transform: "translate(-410.059 -220.57)",
    fill: "#3c71b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1112",
    "data-name": "Path 1112",
    d: "M637.305,333.879h-9.511a1.656,1.656,0,0,1-1.64-1.668V300.523a1.656,1.656,0,0,1,1.64-1.668h9.511a1.656,1.656,0,0,1,1.64,1.668v31.689A1.656,1.656,0,0,1,637.305,333.879Z",
    transform: "translate(-454.412 -197.911)",
    fill: "#3c71b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1113",
    "data-name": "Path 1113",
    d: "M705.3,311.887h-9.511a1.656,1.656,0,0,1-1.64-1.668v-42.7a1.656,1.656,0,0,1,1.64-1.668H705.3a1.656,1.656,0,0,1,1.64,1.668v42.7a1.656,1.656,0,0,1-1.64,1.668Z",
    transform: "translate(-500.111 -175.919)",
    fill: "#3c71b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1114",
    "data-name": "Path 1114",
    d: "M569.561,402.522H472.482a.334.334,0,0,1,0-.667h97.079a.334.334,0,0,1,0,.667Z",
    transform: "translate(-350.92 -266.554)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1115",
    "data-name": "Path 1115",
    d: "M898.052,578.318a3.264,3.264,0,0,1,5.024-.581l10.415-5.467-.648,6.159-9.791,4.247a3.274,3.274,0,0,1-4.4.08,3.413,3.413,0,0,1-.6-4.438Z",
    transform: "translate(-636.759 -412.846)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1116",
    "data-name": "Path 1116",
    d: "M923.669,535.943a1.5,1.5,0,0,1-.5-.738l-.828-2.722a1.521,1.521,0,0,1,.521-1.641l8.441-6.485,9.142-17.249a4.7,4.7,0,0,1,6.671-.854,4.891,4.891,0,0,1,.84,6.785l-5.2,11.164a15.327,15.327,0,0,1-7.7,7.571l-9.892,4.364a1.459,1.459,0,0,1-1.5-.2Z",
    transform: "translate(-653.416 -368.174)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_39",
    "data-name": "Ellipse 39",
    cx: 8.055,
    cy: 8.193,
    rx: 8.055,
    ry: 8.193,
    transform: "translate(286.714 115.349)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1117",
    "data-name": "Path 1117",
    d: "M876.655,654.222h-4.021l-1.912-15.774h5.934Z",
    transform: "translate(-585.153 -423.206)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1118",
    "data-name": "Path 1118",
    d: "M857.79,682.233h7.755V687.2H852.908A4.925,4.925,0,0,1,857.79,682.233Z",
    transform: "translate(-573.181 -452.386)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1119",
    "data-name": "Path 1119",
    d: "M916.655,654.223h-4.02l-1.912-15.774h5.935Z",
    transform: "translate(-612.034 -423.207)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1120",
    "data-name": "Path 1120",
    d: "M897.791,682.234h7.754V687.2H892.908A4.925,4.925,0,0,1,897.791,682.234Z",
    transform: "translate(-600.063 -452.387)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1121",
    "data-name": "Path 1121",
    d: "M981.123,664.217h-4.712a1.483,1.483,0,0,1-1.425-1.11L968.2,637.521a.164.164,0,0,0-.185-.121.166.166,0,0,0-.137.174l1.37,24.264a1.514,1.514,0,0,1-.443,1.161,1.461,1.461,0,0,1-1.153.421l-5.3-.449a1.492,1.492,0,0,1-1.343-1.322l-4.825-50.95,1.867,1.139,17.49-3.02,7.038,53.7a1.52,1.52,0,0,1-.353,1.187,1.465,1.465,0,0,1-1.11.512Z",
    transform: "translate(-676.208 -437.203)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1122",
    "data-name": "Path 1122",
    d: "M961.333,542.058a10.669,10.669,0,0,1-5.474-1.567,1.5,1.5,0,0,1-.7-1.531c.615-3.831,3.832-23.486,6.759-34.2,1.192-4.364,3.828-6.714,7.834-6.986a11.212,11.212,0,0,1,11.611,10.407c.957,10.824-2.93,26.2-4.645,32.311a1.489,1.489,0,0,1-.961,1.013,1.455,1.455,0,0,1-1.363-.244l-3.5-2.766a1.144,1.144,0,0,0-1.481.063A11.905,11.905,0,0,1,961.333,542.058Z",
    transform: "translate(-675.501 -363.184)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1123",
    "data-name": "Path 1123",
    d: "M904.1,443.738l2.952,12.676-4.264,10.674,2.952-10.34Z",
    transform: "translate(-606.7 -293.445)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1124",
    "data-name": "Path 1124",
    d: "M989.881,449.577a5.343,5.343,0,0,0,2.095-.385c.293-.115.6-.209.89-.324a7.348,7.348,0,0,0,4.349-6.633,9.615,9.615,0,0,0-3.5-7.355,13.429,13.429,0,0,0-7.653-2.942c-2.976-.231-6.328.537-7.991,3.058a2.691,2.691,0,0,0-.49,2.3,1.472,1.472,0,0,0,.407.636c.743.672,1.483.167,2.24.122a2.483,2.483,0,0,1,2.311,1.8,5.508,5.508,0,0,1-.083,3.132,7.955,7.955,0,0,0-.388,1.9,1.927,1.927,0,0,0,.78,1.686,2.118,2.118,0,0,0,2.155-.231,14.96,14.96,0,0,1,1.916-1.248,1.675,1.675,0,0,1,2.056.423,2.338,2.338,0,0,1,.26.763c.367,1.7.283,1.6.649,3.3Z",
    transform: "translate(-690.515 -319.297)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1125",
    "data-name": "Path 1125",
    d: "M869.11,628.015l-50.44-17.866a3.536,3.536,0,0,1-2.128-4.478l13.108-38.279a2.526,2.526,0,0,1,3.226-1.586l52.145,18.47a2.636,2.636,0,0,1,1.586,3.338L873.513,625.85A3.448,3.448,0,0,1,869.11,628.015Z",
    transform: "translate(-582.229 -408.443)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    "data-name": "Path 1126",
    d: "M831.936,617.428l44.106,15.623a3.34,3.34,0,0,0,4.27-2.1L890.9,600.04a3.426,3.426,0,0,0-2.064-4.343l-44.107-15.623a3.339,3.339,0,0,0-4.27,2.1l-10.584,30.91a3.425,3.425,0,0,0,2.064,4.343Z",
    transform: "translate(-591.191 -417.921)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1127",
    "data-name": "Path 1127",
    d: "M865.193,619.475l-2.184-.774a.484.484,0,0,1-.291-.613l.761-2.222a.472.472,0,0,1,.6-.3l2.184.774a.484.484,0,0,1,.291.613l-.761,2.222A.472.472,0,0,1,865.193,619.475Z",
    transform: "translate(-613.373 -441.686)",
    fill: "#3c71b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1128",
    "data-name": "Path 1128",
    d: "M859.184,636.731,857,635.958a.484.484,0,0,1-.291-.613l.761-2.222a.471.471,0,0,1,.6-.3l2.184.774a.484.484,0,0,1,.291.613l-.761,2.222A.472.472,0,0,1,859.184,636.731Z",
    transform: "translate(-609.335 -453.186)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1129",
    "data-name": "Path 1129",
    d: "M853.174,653.987l-2.184-.774a.484.484,0,0,1-.291-.613l.761-2.222a.472.472,0,0,1,.6-.3l2.184.774a.484.484,0,0,1,.291.613l-.761,2.222A.472.472,0,0,1,853.174,653.987Z",
    transform: "translate(-605.296 -464.686)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1130",
    "data-name": "Path 1130",
    d: "M892.857,629.864l-10.525-3.728a.483.483,0,0,1-.291-.613.471.471,0,0,1,.6-.3l10.525,3.728a.483.483,0,0,1,.291.613A.471.471,0,0,1,892.857,629.864Z",
    transform: "translate(-626.36 -448.121)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1131",
    "data-name": "Path 1131",
    d: "M886.848,647.119l-10.525-3.728a.483.483,0,0,1-.291-.613.471.471,0,0,1,.6-.3l10.525,3.728a.483.483,0,0,1,.291.613A.471.471,0,0,1,886.848,647.119Z",
    transform: "translate(-622.321 -459.621)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1132",
    "data-name": "Path 1132",
    d: "M880.838,664.375l-10.524-3.728a.483.483,0,0,1-.291-.613.471.471,0,0,1,.6-.3l10.525,3.728a.483.483,0,0,1,.291.613A.471.471,0,0,1,880.838,664.375Z",
    transform: "translate(-618.283 -471.121)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1133",
    "data-name": "Path 1133",
    d: "M969.3,656.243q.115-.281.215-.571a10.13,10.13,0,0,0-6.1-12.843l-3.459,10.1Z",
    transform: "translate(-678.735 -459.87)",
    fill: "#3c71b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1134",
    "data-name": "Path 1134",
    d: "M936.962,653.648l3.46-10.1a9.873,9.873,0,0,0-12.56,6.016,10.141,10.141,0,0,0,5.66,12.893,9.86,9.86,0,0,0,12.788-5.5Z",
    transform: "translate(-656.751 -459.971)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1135",
    "data-name": "Path 1135",
    d: "M994.623,602.643a3.387,3.387,0,0,1,.971-2.661,3.265,3.265,0,0,1,2.63-.951l4.878-10.838,3.227,5.253-5.127,9.487a3.31,3.31,0,0,1-6.58-.29Z",
    transform: "translate(-702.028 -423.458)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1136",
    "data-name": "Path 1136",
    d: "M1011.587,543.993a1.46,1.46,0,0,1-.841-.267l-2.3-1.622a1.519,1.519,0,0,1-.587-1.618l2.707-10.4-3.273-19.311a4.755,4.755,0,1,1,9.509-.047l2.682,12.049a15.7,15.7,0,0,1-1.461,10.787l-5.134,9.643a1.481,1.481,0,0,1-.955.745A1.436,1.436,0,0,1,1011.587,543.993Z",
    transform: "translate(-710.549 -368.626)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1150",
    "data-name": "Path 1150",
    d: "M230.775,525.616,179.357,547.07a3.582,3.582,0,0,1-4.695-2l-15.74-39.021a2.7,2.7,0,0,1,1.438-3.5l53.156-22.179a2.669,2.669,0,0,1,3.5,1.488l15.722,38.979A3.686,3.686,0,0,1,230.775,525.616Z",
    transform: "translate(-140.285 -351.468)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1151",
    "data-name": "Path 1151",
    d: "M191.4,552.455l44.961-18.76a3.57,3.57,0,0,0,1.9-4.63l-12.71-31.509a3.469,3.469,0,0,0-4.553-1.936l-44.961,18.76a3.57,3.57,0,0,0-1.9,4.63l12.71,31.51a3.469,3.469,0,0,0,4.553,1.936Z",
    transform: "translate(-150.468 -361.586)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1170",
    "data-name": "Path 1170",
    d: "M0,0,.717,0V.121L0,.125Z",
    transform: "translate(74.178 144.834) rotate(-22.306)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1152",
    "data-name": "Path 1152",
    d: "M239.828,530.327l-1.335.557-.045-.112,1.335-.557Zm-2.671,1.114-1.335.557-.045-.112,1.335-.557Zm-2.671,1.114-1.335.557-.045-.112,1.335-.557Zm-2.671,1.114-1.335.557-.045-.112,1.335-.557Zm-2.671,1.114-1.335.557-.045-.112,1.335-.557Zm-2.671,1.114-1.335.557-.045-.112,1.335-.557Zm-2.671,1.114-1.335.557-.045-.112,1.335-.557Zm-2.671,1.114-1.335.557-.045-.112,1.335-.557Zm-2.671,1.114-1.335.557-.045-.112,1.335-.557Zm-2.671,1.114-1.335.557-.045-.112,1.335-.557Zm-2.671,1.114-1.335.557-.045-.112,1.335-.557Zm-2.671,1.114-1.335.557-.045-.112,1.335-.557Zm-2.671,1.114-1.335.557-.045-.112,1.335-.557Zm-2.671,1.115-1.335.557-.045-.112,1.335-.557Zm-2.671,1.114-1.335.557-.045-.112,1.335-.557Zm-2.671,1.114-1.335.557-.045-.112,1.335-.557Z",
    transform: "translate(-166.938 -384.82)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1171",
    "data-name": "Path 1171",
    d: "M0,0,.717,0V.121L0,.125Z",
    transform: "translate(29.449 163.498) rotate(-22.306)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1172",
    "data-name": "Path 1172",
    d: "M0,0,.717,0V.121L0,.125Z",
    transform: "translate(56.678 164.311) rotate(-22.306)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1153",
    "data-name": "Path 1153",
    d: "M230.919,588.691l-1.316.549-.045-.112,1.316-.549Zm-2.631,1.1-1.316.549-.045-.112,1.316-.549Zm-2.631,1.1-1.316.549-.045-.112,1.316-.549Zm-2.631,1.1-1.316.549-.045-.112,1.315-.549Zm-2.631,1.1-1.316.549-.045-.112,1.316-.549Zm-2.631,1.1-1.316.549-.045-.112,1.316-.549Zm-2.631,1.1-1.316.549-.045-.112,1.316-.549Zm-2.631,1.1-1.316.549-.045-.112,1.316-.549Z",
    transform: "translate(-175.51 -423.715)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1173",
    "data-name": "Path 1173",
    d: "M0,0,.717,0V.121L0,.125Z",
    transform: "translate(33.652 173.919) rotate(-22.306)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1174",
    "data-name": "Path 1174",
    d: "M0,0,.717,0V.121L0,.125Z",
    transform: "translate(45.776 174.62) rotate(-22.306)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1154",
    "data-name": "Path 1154",
    d: "M224.133,619.643l-1.354.565-.045-.112,1.354-.565Zm-2.707,1.13-1.354.565-.045-.112,1.353-.565Zm-2.707,1.13-1.354.565-.045-.112,1.354-.565Z",
    transform: "translate(-179.663 -444.343)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1175",
    "data-name": "Path 1175",
    d: "M0,0,.717,0V.121L0,.125Z",
    transform: "translate(35.641 178.849) rotate(-22.306)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1176",
    "data-name": "Path 1176",
    d: "M0,0,.717,0V.121L0,.125Z",
    transform: "translate(49.17 183.033) rotate(-22.306)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1155",
    "data-name": "Path 1155",
    d: "M234.481,644.866l-1.353.565-.045-.112,1.354-.565ZM231.774,646l-1.354.565-.045-.112,1.354-.565Zm-2.707,1.129-1.354.565-.045-.112,1.354-.565Z",
    transform: "translate(-186.617 -461.152)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1177",
    "data-name": "Path 1177",
    d: "M0,0,.717,0V.121L0,.125Z",
    transform: "translate(39.034 187.262) rotate(-22.306)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1156",
    "data-name": "Path 1156",
    d: "M233.132,571.807l38.1-15.9a3.853,3.853,0,0,0,2.052-4.991l-7.7-19.085-.074.034-9.35,22.738-6.935-2.949a.886.886,0,0,0-.8.051.97.97,0,0,0-.4.478l-4.9,11.916-5.07-2.156a.9.9,0,0,0-1.182.493C236.848,562.518,233.721,570.32,233.132,571.807Z",
    transform: "translate(-190.289 -385.898)",
    fill: "#3c71b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1157",
    "data-name": "Path 1157",
    d: "M232.55,571.548l-.11-.047,3.921-9.535a1.007,1.007,0,0,1,1.324-.553l4.97,2.114,4.872-11.85a1.007,1.007,0,0,1,1.324-.553l6.835,2.907,9.4-22.857.11.047L255.75,554.19l-6.945-2.954a.888.888,0,0,0-1.168.488l-4.918,11.962-5.08-2.161a.889.889,0,0,0-1.169.488Z",
    transform: "translate(-189.824 -385.459)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_41",
    "data-name": "Ellipse 41",
    cx: 0.834,
    cy: 0.848,
    rx: 0.834,
    ry: 0.848,
    transform: "translate(45.629 173.556)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_42",
    "data-name": "Ellipse 42",
    cx: 0.834,
    cy: 0.848,
    rx: 0.834,
    ry: 0.848,
    transform: "translate(56.53 163.247)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_43",
    "data-name": "Ellipse 43",
    cx: 0.834,
    cy: 0.848,
    rx: 0.834,
    ry: 0.848,
    transform: "translate(73.504 143.741)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1158",
    "data-name": "Path 1158",
    d: "M177,555.078a3.358,3.358,0,0,0,1.745-2.229,3.413,3.413,0,0,0-.561-2.792l2.476-24.619h-5.35l-1.967,24.039a3.426,3.426,0,0,0-.617,4.453A3.3,3.3,0,0,0,177,555.078Z",
    transform: "translate(-149.32 -381.636)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_44",
    "data-name": "Ellipse 44",
    cx: 7.57,
    cy: 7.699,
    rx: 7.57,
    ry: 7.699,
    transform: "translate(25.024 114.818)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1159",
    "data-name": "Path 1159",
    d: "M191.991,517.056a1.388,1.388,0,0,1-1.334-1.034,78.591,78.591,0,0,0-4.69-11.262,9.474,9.474,0,0,1-.234-7.627,9.241,9.241,0,0,1,5.442-5.253h0a9.028,9.028,0,0,1,7.125.438,9.281,9.281,0,0,1,4.656,5.5,46.9,46.9,0,0,1,1.718,15.389,1.407,1.407,0,0,1-1.089,1.306l-11.3,2.509A1.355,1.355,0,0,1,191.991,517.056Z",
    transform: "translate(-157.972 -358.917)",
    fill: "#ff6584"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1160",
    "data-name": "Path 1160",
    d: "M137.081,656.811h3.778l1.8-14.823H137.08Z",
    transform: "translate(-92.122 -425.566)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1161",
    "data-name": "Path 1161",
    d: "M0,0H11.875V4.666H4.588A4.628,4.628,0,0,1,0,0H0Z",
    transform: "translate(56.023 234.813) rotate(179.997)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1162",
    "data-name": "Path 1162",
    d: "M21.882,645.544l3.311,1.851,8.6-12.108L28.9,632.555Z",
    transform: "translate(-14.705 -419.279)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1163",
    "data-name": "Path 1163",
    d: "M0,0,11.922.086l.033,4.648L4.639,4.681A4.708,4.708,0,0,1,0,0H0Z",
    transform: "translate(15.183 234.813) rotate(-151.199)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1164",
    "data-name": "Path 1164",
    d: "M169.119,623.55a1.4,1.4,0,0,1-1.374-1.229l-4.726-37.034a.778.778,0,0,0-.62-.669.766.766,0,0,0-.818.391l-19.693,36.339a1.384,1.384,0,0,1-1.708.638l-4.293-1.663a1.4,1.4,0,0,1-.778-.756,1.433,1.433,0,0,1-.013-1.094l13.642-34.084a1.1,1.1,0,0,0,.07-.27c1.848-14.545,6.549-21.942,7.946-23.862a1.108,1.108,0,0,0,.153-.995l-.192-.586a1.428,1.428,0,0,1,.267-1.372c5.033-5.831,13.806-2.649,13.894-2.616l.044.017.028.038c9.837,13.721,6.2,58.284,5.371,67.079a1.394,1.394,0,0,1-1.274,1.269l-5.817.455C169.19,623.549,169.154,623.55,169.119,623.55Z",
    transform: "translate(-124.337 -400.532)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1165",
    "data-name": "Path 1165",
    d: "M250.7,483.364a3.364,3.364,0,0,0-.074.514l-13.239,7.768-3.218-1.884-3.431,4.568,5.378,3.9a2.433,2.433,0,0,0,2.958-.073L252.73,487.2a3.2,3.2,0,0,0,3.563-.926,3.335,3.335,0,0,0,.41-3.717,3.221,3.221,0,0,0-3.273-1.7,3.256,3.256,0,0,0-2.726,2.511Z",
    transform: "translate(-188.683 -351.904)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1166",
    "data-name": "Path 1166",
    d: "M223.622,501.641l-4.279,5.64a1.372,1.372,0,0,1-2.1.117l-4.844-5.116a3.962,3.962,0,0,1-.681-5.5,3.808,3.808,0,0,1,5.4-.692l6.075,3.455a1.409,1.409,0,0,1,.682.948,1.429,1.429,0,0,1-.261,1.144Z",
    transform: "translate(-175.356 -361.531)",
    fill: "#ff6584"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1167",
    "data-name": "Path 1167",
    d: "M182.637,517.684l-6.893-1.266a1.388,1.388,0,0,1-.948-.671,1.432,1.432,0,0,1-.12-1.168l2.235-6.729a3.857,3.857,0,0,1,4.484-3.146,3.913,3.913,0,0,1,3.093,4.56l-.218,7.076a1.419,1.419,0,0,1-.514,1.052,1.37,1.37,0,0,1-1.119.292Z",
    transform: "translate(-150.956 -367.775)",
    fill: "#ff6584"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1168",
    "data-name": "Path 1168",
    d: "M149.713,437.339c1.946,1.354,4.5,2.746,6.487,1.3a3.716,3.716,0,0,0,1.187-4.239c-.951-2.767-3.566-3.986-6.065-4.919-3.25-1.214-6.788-2.18-10.143-1.31s-6.32,4.173-5.714,7.64c.487,2.788,3.073,5.108,2.706,7.915-.369,2.825-3.493,4.312-6.251,4.817s-5.843.667-7.825,2.682c-2.528,2.57-1.9,7.163.482,9.877s5.969,3.943,9.447,4.779c4.609,1.108,9.594,1.69,13.971-.148s7.784-6.788,6.516-11.428a16.008,16.008,0,0,0-3.017-5.23,14.644,14.644,0,0,1-2.919-5.278,5.56,5.56,0,0,1,.974-4.8,1.409,1.409,0,0,0,.183-1.626Z",
    transform: "translate(-115.922 -316.593)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1169",
    "data-name": "Path 1169",
    d: "M425.807,797.508H104.193c-.935,0-1.693-.149-1.693-.333s.758-.334,1.693-.334H425.807c.935,0,1.693.149,1.693.334S426.742,797.508,425.807,797.508Z",
    transform: "translate(-102.5 -562.508)",
    fill: "#2f2e41"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectImg);
export default __webpack_public_path__ + "static/media/connectImg.31a9060a91f796d9dc99a92fe68cd8a3.svg";
export { ForwardRef as ReactComponent };